import { TableCell, Typography, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

import { TypographyProps } from '@mui/material/Typography';
import './title-cell.scss';

interface RaterTableExcessTitleCellTypographyProps extends TypographyProps {
  isError?: boolean;
}

const RaterTableExcessTitleCellTypography = styled(
  Typography
)<RaterTableExcessTitleCellTypographyProps>(({ isError }) => ({
  minHeight: '37px',
  display: 'flex',
  alignItems: 'center',
  color: isError ? 'black' : '#ffffff',
  fontWeight: 'bold',
  fontSize: 'small',
}));

export const RaterTableExcessTitleCell = ({
  children,
  columnCount,
  isError,
}: PropsWithChildren & { columnCount: number; isError?: boolean }) => {
  return (
    <TableCell colSpan={columnCount} className="title-cell-container">
      {typeof children === 'string' || typeof children === 'number' ? (
        <RaterTableExcessTitleCellTypography isError={isError}>
          {children}
        </RaterTableExcessTitleCellTypography>
      ) : (
        children
      )}
    </TableCell>
  );
};

RaterTableExcessTitleCell.Typography = RaterTableExcessTitleCellTypography;
